import "./HeroimgStyles.css"
import React from 'react'

const HeroSportImg = () => {
  return (
    <div className="hero">
        <div className="mask">
            <img className="hero-img" src="https://media.gustech.tec.br/images/soccer.jpg" alt="HeroImg" />
        </div>
    </div>
  )
}

export default HeroSportImg